import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen pt-24 pb-16 px-4 overflow-hidden" data-id="element-53">
      {/* Blurred Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-54">
        <img src="https://cdn.magicpatterns.com/uploads/x8AMYd4jZEPUhc4jKZ1W2q/Firefly_Gemini_Flash_Haceme_una_tarotista_dando_una_carta_natal_que_la_foto_se_vea_sumamente_profesional_m_10276.png" alt="" className="w-full h-full object-cover" style={{
        filter: 'blur(12px)',
        transform: 'scale(1.05)'
      }} data-id="element-55" />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-[#1a1040]/75" data-id="element-56" />
        {/* Bottom gradient fade into page */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#1a1040]" data-id="element-57" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-58">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-[#F5C842]/40 rounded-full px-6 py-2 mb-8" data-id="element-59">
          <span className="text-[#F5C842]" data-id="element-60">⭐</span>
          <span className="text-white font-semibold text-sm md:text-base uppercase tracking-wider" data-id="element-61">
            El Sistema #1 Para Astrólogas
          </span>
          <span className="text-[#F5C842]" data-id="element-62">⭐</span>
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 leading-tight mystic-glow drop-shadow-lg" data-id="element-63">
          SISTEMA PRO <span className="text-gold-gradient" data-id="element-64">CARTAS NATALES</span>
        </h1>

        {/* Product Image - Clickable */}
        <a href="#comprar" className="block cursor-pointer transition-transform hover:scale-105 duration-300" data-id="element-65">
          <img src="https://cdn.magicpatterns.com/uploads/egSk7yA3Ya5VsD7DeFvht1/Mockup_principal.png" alt="Sistema Pro Cartas Natales - Informes profesionales para astrólogas" className="max-w-full md:max-w-3xl mx-auto drop-shadow-2xl" data-id="element-66" />
        </a>

        {/* Subheading - Below mockup */}
        <p className="text-lg md:text-xl text-white mt-6 mb-8 max-w-2xl mx-auto leading-relaxed drop-shadow-md" data-id="element-67">
          Sistema completo de informes astrológicos profesionales listos para
          entregar. Todo tu flujo de trabajo anual resuelto en un clic.
        </p>

        {/* CTA Button */}
        <div data-id="element-68">
          <CTAButton href="#comprar" size="large" data-id="element-69">
            ¡QUIERO EL SISTEMA AHORA!
          </CTAButton>
        </div>
      </div>
    </section>;
}